document.addEventListener('DOMContentLoaded', function() {
  const sectionId = window.multiSliderTabsSectionId;
  
  const tabsSlider = document.querySelector(`#tabs-swiper-${sectionId}`);
  const tabsWrapper = tabsSlider.querySelector(".swiper-wrapper");
  let tabsSwiperInstance = null;

  function getTabSlides() {
    return tabsWrapper.querySelectorAll(".swiper-slide:not(.cloned-slide)");
  }

  function getTabClones() {
    return tabsWrapper.querySelectorAll(".cloned-slide");
  }

  function isMobile() {
    return window.innerWidth < 768;
  }

  function duplicateTabSlidesIfNeeded() {
    const slides = getTabSlides();
    const cloneCount = getTabClones().length;

    if (isMobile() && slides.length > 0 && cloneCount === 0) {
      slides.forEach((slide, index) => {
        const clone = slide.cloneNode(true);
        clone.classList.add("cloned-slide");
        const clonedTab = clone.querySelector('.multi-slider-tabs__tab');
        if (clonedTab) {
          clonedTab.dataset.slide = index;
        }
        tabsWrapper.appendChild(clone);
      });
    }

    if (!isMobile() && cloneCount > 0) {
      getTabClones().forEach(clone => clone.remove());
    }
  }

  function initTabsSwiper() {
    const slideCount = getTabSlides().length;

    if (slideCount <= 2) {
      destroyTabsSwiper();
      return;
    }

    duplicateTabSlidesIfNeeded();

    if (tabsSwiperInstance) tabsSwiperInstance.destroy(true, true);

    const mobile = isMobile();
    
    tabsSwiperInstance = new Swiper(`#tabs-swiper-${sectionId}`, {
      slidesPerView: 'auto',
      spaceBetween: mobile ? 26 : 0,
      centeredSlides: mobile,
      loop: mobile,
      freeMode: false,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 0,
          freeMode: false,
          loop: false,
        },
      }
    });
    
    attachTabsSwiperEvents();
  }

  function destroyTabsSwiper() {
    if (tabsSwiperInstance) {
      tabsSwiperInstance.destroy(true, true);
      tabsSwiperInstance = null;
    }
  }

  function handleTabsResize() {
    initTabsSwiper();
  }

  function debounce(func, delay) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(func, delay);
    };
  }

  handleTabsResize();
  window.addEventListener("resize", debounce(handleTabsResize, 200));

  const imagesSlider = document.querySelector(`#images-swiper-${sectionId}`);
  const imagesWrapper = imagesSlider.querySelector(".swiper-wrapper");
  let imagesSwiperInstance = null;

  const contentSlider = document.querySelector(`#content-swiper-${sectionId}`);
  const contentWrapper = contentSlider.querySelector(".swiper-wrapper");
  let contentSwiperInstance = null;

  function getImageSlides() {
    return imagesWrapper.querySelectorAll(".swiper-slide:not(.cloned-slide)");
  }

  function getImageClones() {
    return imagesWrapper.querySelectorAll(".cloned-slide");
  }

  function getContentSlides() {
    return contentWrapper.querySelectorAll(".swiper-slide:not(.cloned-slide)");
  }

  function getContentClones() {
    return contentWrapper.querySelectorAll(".cloned-slide");
  }

  function duplicateImageSlidesIfNeeded() {
    const slides = getImageSlides();
    const cloneCount = getImageClones().length;

    if (isMobile() && slides.length > 0 && cloneCount === 0) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add("cloned-slide");
        imagesWrapper.appendChild(clone);
      });
    }

    if (!isMobile() && cloneCount > 0) {
      getImageClones().forEach(clone => clone.remove());
    }
  }

  function duplicateContentSlidesIfNeeded() {
    const slides = getContentSlides();
    const cloneCount = getContentClones().length;

    if (isMobile() && slides.length > 0 && cloneCount === 0) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add("cloned-slide");
        contentWrapper.appendChild(clone);
      });
    }

    if (!isMobile() && cloneCount > 0) {
      getContentClones().forEach(clone => clone.remove());
    }
  }

  function initImagesSwiper() {
    const slideCount = getImageSlides().length;

    if (slideCount <= 2) {
      destroyImagesSwiper();
      return;
    }

    duplicateImageSlidesIfNeeded();

    if (imagesSwiperInstance) imagesSwiperInstance.destroy(true, true);

    const mobile = isMobile();
    
    imagesSwiperInstance = new Swiper(`#images-swiper-${sectionId}`, {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      loop: mobile,
    });
    
    attachImagesSwiperEvents();
  }

  function initContentSwiper() {
    const slideCount = getContentSlides().length;

    if (slideCount <= 2) {
      destroyContentSwiper();
      return;
    }

    duplicateContentSlidesIfNeeded();

    if (contentSwiperInstance) contentSwiperInstance.destroy(true, true);

    const mobile = isMobile();
    
    contentSwiperInstance = new Swiper(`#content-swiper-${sectionId}`, {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      loop: mobile,
    });
    
    attachContentSwiperEvents();
  }

  function destroyImagesSwiper() {
    if (imagesSwiperInstance) {
      imagesSwiperInstance.destroy(true, true);
      imagesSwiperInstance = null;
    }
  }

  function destroyContentSwiper() {
    if (contentSwiperInstance) {
      contentSwiperInstance.destroy(true, true);
      contentSwiperInstance = null;
    }
  }

  function handleImagesResize() {
    initImagesSwiper();
  }

  function handleContentResize() {
    initContentSwiper();
  }

  handleImagesResize();
  handleContentResize();
  
  window.addEventListener("resize", debounce(handleImagesResize, 200));
  window.addEventListener("resize", debounce(handleContentResize, 200));

  let isSyncing = false;

  function syncSwipers(activeIndex, fromSwiper = null) {
    if (isSyncing) return;
    isSyncing = true;
    
    let realIndex = activeIndex;
    const originalSlideCount = getTabSlides().length;
    
    realIndex = realIndex % originalSlideCount;
    
    if (fromSwiper !== 'images' && imagesSwiperInstance) {
      if (imagesSwiperInstance.slideToLoop) {
        imagesSwiperInstance.slideToLoop(realIndex);
      } else {
        imagesSwiperInstance.slideTo(realIndex);
      }
    }
    
    if (fromSwiper !== 'content' && contentSwiperInstance) {
      if (contentSwiperInstance.slideToLoop) {
        contentSwiperInstance.slideToLoop(realIndex);
      } else {
        contentSwiperInstance.slideTo(realIndex);
      }
    }
    
    if (fromSwiper !== 'tabs' && tabsSwiperInstance) {
      if (tabsSwiperInstance.slideToLoop) {
        tabsSwiperInstance.slideToLoop(realIndex);
      } else {
        tabsSwiperInstance.slideTo(realIndex);
      }
    }
    
    document.querySelectorAll(`#multi-slider-${sectionId} .swiper-slide:not(.cloned-slide) .multi-slider-tabs__tab`).forEach((tab, index) => {
      tab.classList.toggle('active', index === realIndex);
    });
    
    document.querySelectorAll(`#multi-slider-${sectionId} .current-slide`).forEach(counter => {
      counter.textContent = realIndex + 1;
    });
    
    setTimeout(() => {
      isSyncing = false;
    }, 50);
  }

  function attachTabClickHandlers() {
    document.querySelectorAll(`#multi-slider-${sectionId} .multi-slider-tabs__tab`).forEach((tab, globalIndex) => {
      tab.addEventListener('click', function() {
        const slideIndex = parseInt(this.dataset.slide);
        const originalSlideCount = getTabSlides().length;
        const realIndex = slideIndex % originalSlideCount;
        syncSwipers(realIndex, 'tabs');
      });
    });
  }

  attachTabClickHandlers();

  function reattachHandlers() {
    setTimeout(() => {
      attachTabClickHandlers();
    }, 100);
  }

  const originalHandleTabsResize = handleTabsResize;
  handleTabsResize = function() {
    originalHandleTabsResize();
    reattachHandlers();
  };

  document.querySelectorAll(`#multi-slider-${sectionId} .multi-slider-tabs__next-btn`).forEach(btn => {
    btn.addEventListener('click', function() {
      const nextSlide = parseInt(this.dataset.nextSlide);
      syncSwipers(nextSlide, 'tabs');
    });
  });

  function attachTabsSwiperEvents() {
    if (tabsSwiperInstance) {
      tabsSwiperInstance.on('slideChange', function() {
        const realIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        syncSwipers(realIndex, 'tabs');
      });
      
      tabsSwiperInstance.on('slideChangeTransitionEnd', function() {
        const realIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        syncSwipers(realIndex, 'tabs');
      });
    }
  }

  function attachImagesSwiperEvents() {
    if (imagesSwiperInstance) {
      imagesSwiperInstance.on('slideChange', function() {
        const realIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        syncSwipers(realIndex, 'images');
      });
      
      imagesSwiperInstance.on('slideChangeTransitionEnd', function() {
        const realIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        syncSwipers(realIndex, 'images');
      });
    }
  }

  function attachContentSwiperEvents() {
    if (contentSwiperInstance) {
      contentSwiperInstance.on('slideChange', function() {
        const realIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        syncSwipers(realIndex, 'content');
      });
      
      contentSwiperInstance.on('slideChangeTransitionEnd', function() {
        const realIndex = this.realIndex !== undefined ? this.realIndex : this.activeIndex;
        syncSwipers(realIndex, 'content');
      });
    }
  }

  if (window.multiSliderTabsAutoplay) {
    setInterval(function() {
      if (imagesSwiperInstance) {
        const currentIndex = imagesSwiperInstance.activeIndex;
        const nextIndex = (currentIndex + 1) % window.multiSliderTabsSlideCount;
        syncSwipers(nextIndex);
      }
    }, window.multiSliderTabsAutoplayDelay);
  }
});
